<template>
  <div class="c-config-content">
    <h4 class="c-config-content__title">{{ $t('queue') }}</h4>
    <div v-if="firstLoading">
      <skeleton-loading>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
        </row>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
        </row>
      </skeleton-loading>
    </div>
    <div v-else>
      <div class="c-template-table table-responsive c-role-table">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>{{ $t('queueName') }}</th>
            <th>{{ $t('ext') }}</th>
            <th class="th-80 text-right">
              <span @click="create" class="btn-add"><i class="icon16-plus-circle-gadient"></i></span>
            </th>
          </tr>
          </thead>
          <tbody v-if="items.length">
          <tr v-for="item in items" :key="item._id">
            <td>{{ item.name }}</td>
            <td>{{ item.ext }}</td>
            <td class="text-right">
              <button @click="del(item._id)" :disabled="delLoading" class="mr-1 btn btn-outline-gray btn-sm is-border-1"
                      type="button">
                <b-spinner v-if="delLoading" small></b-spinner>
                <i v-else class="icon12-delete-primary"></i>
              </button>
              <button @click="update(item._id)" :disabled="updateLoading" class="btn btn-outline-gray btn-sm is-border-1"
                      type="button">
                <b-spinner v-if="updateLoading" small></b-spinner>
                <i v-else class="icon12-edit-primary"></i>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="3" class="text-center text-gray-999">{{ $t('noQueueFound') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
        <b-pagination size="sm" class="pagination pagination-sm justify-content-center"
                      v-model="filterFormModel.page" :total-rows="itemCount"
                      :per-page="filterFormModel.pageSize" @input="load">
        </b-pagination>
      </div>
      <b-modal size="lg" v-model="showForm" :title="formTitle + $t('queueFormTitle')" @ok="save" no-close-on-backdrop
               no-enforce-focus>
        <div class="row">
          <div class="col-md">
            <form-input :label="$t('queueName')" :model="formModel" attribute="name" :errors="formErrors" :placeholder="$t('queueNamePlaceholder')"></form-input>
            <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors" :placeholder="$t('queueExtPlaceholder')"></form-input>
            <form-input :label="$t('timeout')" :model="formModel" attribute="timeout" :errors="formErrors"></form-input>
            <form-select :label="$t('ringStrategy')" :model="formModel" attribute="ringStrategy" :errors="formErrors" :options="ringStrategyOptions"></form-select>
            <form-input :label="$t('agentTimeout')" :model="formModel" attribute="agentTimeout" :errors="formErrors"></form-input>
          </div>
          <div class="col-md">
            <form-input :label="$t('delayTime')" :model="formModel" attribute="delayTime" :errors="formErrors"></form-input>
            <form-input :label="$t('maxNoAnswer')" :model="formModel" attribute="maxNoAnswer" :errors="formErrors"></form-input>
            <recording-select :label="$t('queueGreetRecording')" :model="formModel" attribute="greetRecording" :errors="formErrors"></recording-select>
            <recording-select :label="$t('timeoutRecording')" :model="formModel" attribute="timeoutRecording" :errors="formErrors"></recording-select>
            <div v-if=formModel.timeout>
              <target-select :label="$t('execOnTimeout')" :model="formModel" attribute="execOnTimeout" :errors="formErrors"></target-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md">
            <user-tree-select :label="$t('agent')" :model="formModel" attribute="agents" :errors="formErrors" multiple/>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}
          </b-button>
          <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
            <b-spinner v-if="saveLoading" small></b-spinner>
            {{ $t('save') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import RecordingSelect from "../../../../components/RecordingSelect";
import TargetSelect from "../../../../components/TargetSelect";
import UserTreeSelect from "../../../../components/UserTreeSelect";


export default {
  mixins: [list, crud],
  components: {UserTreeSelect, RecordingSelect, TargetSelect},
  data: function () {
    return {
      service: '/queue',
      autoLoad: true,
      defaultFormModel: {
        timeout: 90,
        agentTimeout: 10,
        ringStrategy: 'round-robin',
        agents: [],
        delayTime: 10,
        maxNoAnswer: 0
      },
      ringStrategyOptions: [
        {value: 'longest-idle-agent', text: this.$t('longestIdleAgent')},
        {value: 'agent-with-least-talk-time', text: this.$t('agentWithLeastTalkTime')},
        {value: 'agent-with-fewest-calls', text: this.$t('agentWithFewestCalls')},
        {value: 'top-down', text: this.$t('topDown')},
        {value: 'round-robin', text: this.$t('roundRobin')},
        {value: 'random', text: this.$t('random')},
        {value: 'ring-all', text: this.$t('ringAll')},
      ],
    }

  },

}
</script>